import { Component, OnInit, Input } from '@angular/core';
import { Question } from 'app/shared/services/app/content/models';

@Component({
  selector: 'tog-question-preview',
  templateUrl: './question-preview.component.html',
  styleUrls: ['./question-preview.component.scss']
})
export class QuestionPreviewComponent implements OnInit {
  multipleChoiceAnswers: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  @Input() questionNumber: number = 1;
  @Input() question: Question;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/page-preview/question-preview/question-preview.component.ts